export const INVENTORIES_QUERY_KEY = 'inventories'
export const INVENTORY_NUMBER_QUERY_KEY = 'inventoryNumber'
